<script>
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <!--
    Panel vacio del dashboard (sin conversacion seleccionada, sin mensajes o sin
    bandeja asignada).

    La version original de la imagen base pintaba el logo a 70rem y al 20% de
    opacidad, y escondia el texto dentro del alt: el agente entraba y solo veia
    una marca de agua gigante, sin saber que tenia que hacer. Aca el logo pasa a
    ser un remate pequenio y el mensaje se muestra de verdad.

    El `message` sigue llegando por prop y NO se hardcodea: el mismo componente
    sirve para los tres estados vacios (CONVERSATION.SELECT_A_CONVERSATION,
    NO_MESSAGE_1 y NO_INBOX_AGENT), y hardcodear "selecciona una conversacion"
    mostraria el texto equivocado en los otros dos.

    El alt va vacio a proposito: el texto ya esta visible al lado, y repetirlo en
    el alt hace que el lector de pantalla lo lea dos veces. El logo es decorativo.

    dtgp-watermark.png ya viene en teal + celeste medio (generar-assets.py), que
    contrasta contra el fondo claro y contra el oscuro: por eso un solo archivo y
    no un par claro/oscuro como logo.svg / logo_dark.svg.
  -->
  <div
    class="flex flex-col items-center justify-center w-full h-full gap-5 px-6"
  >
    <img
      class="w-28 h-auto pointer-events-none select-none"
      src="dashboard/assets/images/dtgp-watermark.png"
      alt=""
    />
    <p
      class="max-w-sm text-base text-center text-n-slate-11 tracking-[0.3px]"
    >
      {{ message }}
    </p>
  </div>
</template>
